"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionContractDeployButton = exports.PREDICTION_CONTRACT_DEPLOY_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const deployPrediction_json_1 = __importDefault(require("@framework/abis/json/PredictionFactoryFacet/deployPrediction.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const dialog_1 = require("./dialog");
exports.PREDICTION_CONTRACT_DEPLOY_DIALOG_KEY = "predictionContractDeploy";
const PredictionContractDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const handleDeploy = () => {
        openFormDialog(exports.PREDICTION_CONTRACT_DEPLOY_DIALOG_KEY, void 0, "button");
    };
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (_values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployPrediction_json_1.default,
            functionName: "deployPrediction",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    config: { treasuryFee: 500n.toString() },
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data: values, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/prediction",
            method: "POST",
            data: {
                contractTemplate: values.contractTemplate,
            },
        }, form);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "PredictionContractDeployButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.PredictionContractDeployDialog, { onExternalConfirm: onDeployConfirm, open: formDialogUniqueKey === `${exports.PREDICTION_CONTRACT_DEPLOY_DIALOG_KEY}.${mode}` })] }));
};
exports.PredictionContractDeployButton = PredictionContractDeployButton;
//# sourceMappingURL=index.js.map